import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the Service Worker for Progressive Web App functionality.
 * Handles error catching and skips registration for bots/crawlers
 * to prevent false positives in SEO reports (Google Search Console).
 */
export function initPWA(): void {
  // 0. Guard for undefined navigator (SSR/Node)
  if (typeof navigator === 'undefined') return;

  // 1. Skip for bots, crawlers, and automated tests
  // Expanded list to catch more crawlers and automation tools
  // Note: navigator.webdriver is true for Playwright/Selenium.
  // We skip SW registration in E2E tests to prevent interference.
  const userAgent = navigator.userAgent || '';
  if (
    navigator.webdriver ||
    /\b(bot|crawler|spider|crawling|googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebookexternalhit|twitterbot|whatsapp|telegram|headlesschrome|phantomjs|selenium)\b/i.test(
      userAgent
    )
  ) {
    return;
  }

  // 2. Register Service Worker via vite-plugin-pwa virtual module
  registerSW({
    onNeedRefresh() {
      // Optional: Show prompt to user about new content
      // For now, autoUpdate is enabled in config, so this might not be hit often
      // unless we change strategy.
      if (import.meta.env.DEV) {
        console.log('New content available, ready to reload.');
      }
    },
    onOfflineReady() {
      if (import.meta.env.DEV) {
        console.log('App is ready to work offline.');
      }
    },
    onRegisterError(error: unknown) {
      if (import.meta.env.DEV) {
        console.warn('SW registration failed:', error);
      } else {
        // Log simplified error in production for debugging (without "Uncaught in promise")
        console.error('[PWA] Registration error:', error);
      }
    },
  });
}
